import apiFetch from '../apiFetch'

export default function (token, legalCompanyId) {
  return apiFetch({ endPoint: `OrganizedUnit/LegalCompany/${legalCompanyId}`, method: 'GET', body: null, token: token })
}
